export const API_BASE_URL_LOCAL = 'http://127.0.0.1:5001/igr-service/us-central1/app/api';
export const API_BASE_URL = 'https://us-central1-igr-service.cloudfunctions.net/app/api';